import _default from './Input';
export { _default as default };